export default "__VITE_ASSET__By4qGrND__"